import React, { useState } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const OTPModal =  (props) =>{
    return(
    <Modal  
        show={props.ConfirmOTP}             
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered 
        backdrop="static"
        onHide={props.setConfirmOTP}
        >
        <Modal.Header closeButton>
            <Modal.Title className='hselect' id="contained-modal-title-vcenter">
            <p className='modal-head-f'>OTP</p><br/> CONFIRMATION
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        
        <p className='form-h3 form-h2'>We have sent you a OTP code . Please enter it below.</p>
        <Form className="text-center" onSubmit={e => e.preventDefault()}>
            <div className="form-group">
            <Form.Control type="text" placeholder="OTP Code" onChange={props.EnteredValue}/> 
            <p className="error-text2">{props.FailMsg} </p>                      
            </div>                        
            <div className="d-flex justify-content-end">                        
            <Button type="button" onClick ={props.ResendOTP}className="btn-logout"  >Resend OTP</Button>
            <Button disabled ={props.confirmdisabled} type="button" onClick ={props.Confirm} className="btn-logout " >Confirm</Button>
            </div>
            {props.children}
        </Form>                                   
        </Modal.Body>
        </Modal>
    );
}
export default OTPModal;